import { useState } from 'react'
import loadYNF from '../utils/loadYNF'

export default function useFormatter (libCodeArr) {
  const [formatter, setFormatter] = useState(() => {
    const formatterMap = {}
    const promises = libCodeArr.map(libCode => {
      return loadYNF(`${libCode}/formatter`, { errReport: false })
        .then($formatter => {
          formatterMap[libCode] = $formatter
        })
        // eslint-disable-next-line
        .catch(err => {})
    })
    return Promise.all(promises).then(() => setFormatter(formatterMap))
  })
  return formatter
}